module.exports = __webpack_public_path__ + "img/Size=32, Style=regular.8cd4046c.svg";